// axios
import axios from 'axios'

const baseURL1 = process.env.VUE_APP_LAPERON_API_1
const baseURL2 = process.env.VUE_APP_LAPERON_API_2
const baseURL3 = process.env.VUE_APP_MPP_API
const apiKey3 = process.env.VUE_APP_MPP_API_KEY
const baseURL4 = process.env.VUE_APP_SKM_API
const baseUrlPkkpr = process.env.VUE_APP_LAPERON_PKKPR
const baseUrlSiposs = process.env.VUE_APP_SIPOSS_API

export const axios1 = axios.create({
  baseURL: baseURL1
  // You can add your headers here
})

export const axios2 = axios.create({
  baseURL: baseURL2
  // You can add your headers here
})

export const axios3 = axios.create({
  baseURL: baseURL3,
  headers: {
    'token': apiKey3
  }
})

export const axios4 = axios.create({
  baseURL: baseURL4
  // You can add your headers here
})

export const axiosPkkpr = axios.create({
  baseURL: baseUrlPkkpr
})

export const axiosSiposs = axios.create({
  baseURL: baseUrlSiposs
})